module.exports = __webpack_public_path__ + "static/hover-marker-base-dbff8081e38a5260388a3d97bcc682ef.png";